import { SettingsProfileType } from '../models';

export const namespace = 'vtn-redact-state-settings-profile';

export interface SettingsProfileState {
  profileList: SettingsProfileType[];
  openSettingsProfileModal: boolean;
  editingProfileId?: string;
  isFetchProfileListInProgress: boolean;
  isAddProfileListInProgress: boolean;
  isEditProfileListInProgress: boolean;
  isDeleteProfileListInProgress: boolean;
}

export const defaultState: SettingsProfileState = {
  profileList: [],
  openSettingsProfileModal: false,
  editingProfileId: undefined,
  isFetchProfileListInProgress: false,
  isAddProfileListInProgress: false,
  isEditProfileListInProgress: false,
  isDeleteProfileListInProgress: false,
};
